<template>
    <div>
        <render-editor-js :content="content.columns[0].content" :component="{}"/>
    </div>
</template>

<script>
    import RenderEditorJs from "./RenderEditorJs";

    export default {
        components: {RenderEditorJs},
        props: ['content'],
        methods: {

        },
        created() {

        }
    };
</script>

<style scoped lang="scss">

</style>
